export enum ChatItemType {
  File = 'file',
  Message = 'message',
  EmployerCallRequest = 'employer_call_request',
  InterviewDates = 'interview_dates',
  Checklist = 'checklist',
}
